import React from 'react';
import PropTypes from 'prop-types';

import { Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupButton extends MagstimInputGroup {

    
    render() {
        return(
            <>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>

                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend"  className="d-none d-md-block">
                        <InputGroupText>{this.props.title}</InputGroupText>
                    </InputGroupAddon>
                    <Button size={CurrentTheme().ControlSize} color="secondary" onClick={this.props.onClick} disabled={this.props.disabled}>{this.props.buttonText}</Button>
                </InputGroup>
            </>
        );
    }
}

MagstimInputGroupButton.propTypes = {
    title: PropTypes.string,
    buttonText: PropTypes.string,
    onClick:PropTypes.func,
    disabled: PropTypes.bool
};

MagstimInputGroupButton.defaultProps = {
    title: "",
    buttonText: "",
    onClick:undefined,
    disabled: false
};

export default MagstimInputGroupButton;